import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-208a5194"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "follow-up" }
const _hoisted_2 = {
  key: 0,
  class: "section-heading"
}
const _hoisted_3 = {
  key: 1,
  class: "section-heading"
}
const _hoisted_4 = { class: "section-heading" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Follow Up", -1))
const _hoisted_6 = { class: "search" }
const _hoisted_7 = { class: "search-inputs" }
const _hoisted_8 = { class: "search-bar" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-hm" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search fa-lg" })
], -1))
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "seperator" }, null, -1))
const _hoisted_12 = { class: "filter" }
const _hoisted_13 = { class: "form-col" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Closing date(range)", -1))
const _hoisted_15 = { class: "date-range" }
const _hoisted_16 = { class: "form-col" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Reinvestigation date(range)", -1))
const _hoisted_18 = { class: "date-range" }
const _hoisted_19 = { class: "form-col" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Investigation type", -1))
const _hoisted_21 = { class: "sml-select" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "All", -1))
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "form-col" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Period", -1))
const _hoisted_26 = { class: "sml-select" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "All", -1))
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "form-col" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Status", -1))
const _hoisted_31 = { class: "sml-select" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "All", -1))
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "form-col" }
const _hoisted_35 = {
  key: 0,
  class: "reset-filter"
}
const _hoisted_36 = { class: "ma-4" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Show", -1))
const _hoisted_38 = { style: {"display":"flex"} }
const _hoisted_39 = { style: {"float":"left"} }
const _hoisted_40 = { class: "radio" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "Routine follow up")
], -1))
const _hoisted_42 = {
  class: "ml-4",
  style: {"float":"left"}
}
const _hoisted_43 = { class: "radio" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "Cause driven follow up")
], -1))
const _hoisted_45 = {
  class: "bottom-half",
  style: {"width":"100%","overflow":"auto"}
}
const _hoisted_46 = { class: "ls-table" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "text" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-up" }, null, -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = { key: 0 }
const _hoisted_52 = ["colspan"]
const _hoisted_53 = { key: 1 }
const _hoisted_54 = ["colspan"]
const _hoisted_55 = { key: 2 }
const _hoisted_56 = ["colspan"]
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { "data-label": "Practice name" }
const _hoisted_59 = { "data-label": "Practice ID" }
const _hoisted_60 = { "data-label": "Closing date" }
const _hoisted_61 = { "data-label": "Last inv type" }
const _hoisted_62 = { "data-label": "Re inv data" }
const _hoisted_63 = { "data-label": "Inv type" }
const _hoisted_64 = { "data-label": "Action" }
const _hoisted_65 = ["onClick", "disabled"]
const _hoisted_66 = ["onClick", "disabled"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_date_picker = _resolveComponent("date-picker")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.loadingDataSet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_LoadingIndicator)
        ]))
      : (_ctx.errorLoadingDataSet)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_ErrorIndicator)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      placeholder: "Search practice name or ID",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.searchKeyword) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.searchKeyword]
                    ]),
                    _hoisted_9
                  ])
                ]),
                _createElementVNode("button", {
                  class: "btn btn-default transparent mr-2",
                  disabled: _ctx.loadingContent,
                  onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.showAdvancedFilter = !_ctx.showAdvancedFilter), ["prevent","stop"]))
                }, [
                  _createTextVNode(" Advanced Filter"),
                  _createElementVNode("span", null, [
                    _createElementVNode("i", {
                      class: _normalizeClass(['fal', _ctx.showAdvancedFilter ? 'fa-angle-up' : 'fa-angle-down'])
                    }, null, 2)
                  ])
                ], 8, _hoisted_10)
              ]),
              (_ctx.showAdvancedFilter)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_date_picker, {
                            value: _ctx.closingDateRange,
                            "onUpdate:value": _cache[2] || (_cache[2] = $event => ((_ctx.closingDateRange) = $event)),
                            range: "",
                            format: "DD/MM/YYYY",
                            "input-class": "narrow"
                          }, null, 8, ["value"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_date_picker, {
                            value: _ctx.reinvestigationDateRange,
                            "onUpdate:value": _cache[3] || (_cache[3] = $event => ((_ctx.reinvestigationDateRange) = $event)),
                            range: "",
                            format: "DD/MM/YYYY",
                            "input-class": "narrow"
                          }, null, 8, ["value"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _createElementVNode("div", _hoisted_21, [
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.advanceFilter.investigationTypeId) = $event))
                          }, [
                            _hoisted_22,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.investigationTypes, (iT) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: iT.id
                              }, _toDisplayString(iT.name), 9, _hoisted_23))
                            }), 256))
                          ], 512), [
                            [_vModelSelect, _ctx.advanceFilter.investigationTypeId]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("div", _hoisted_26, [
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.advanceFilter.period) = $event))
                          }, [
                            _hoisted_27,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.period, (p) => {
                              return (_openBlock(), _createElementBlock("option", { value: p }, _toDisplayString(p), 9, _hoisted_28))
                            }), 256))
                          ], 512), [
                            [_vModelSelect, _ctx.advanceFilter.period]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createElementVNode("div", _hoisted_31, [
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.advanceFilter.statusId) = $event))
                          }, [
                            _hoisted_32,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.followUpStatuses, (s) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: s.id
                              }, _toDisplayString(s.name), 9, _hoisted_33))
                            }), 256))
                          ], 512), [
                            [_vModelSelect, _ctx.advanceFilter.statusId]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("button", {
                          class: "btn btn-secondary sml",
                          onClick: _cache[7] || (_cache[7] = $event => (_ctx.applyFilter()))
                        }, " Apply filter ")
                      ])
                    ]),
                    (_ctx.filterApplied)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createTextVNode(" Or "),
                          _createElementVNode("a", {
                            class: "link2",
                            onClick: _cache[8] || (_cache[8] = $event => {_ctx.resetFilter();})
                          }, "reset all")
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("label", _hoisted_40, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "filter-type",
                      id: "filterType_0",
                      checked: "",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.radioFilter) = $event)),
                      value: 1
                    }, null, 512), [
                      [_vModelRadio, _ctx.radioFilter]
                    ]),
                    _hoisted_41
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("label", _hoisted_43, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "filter-type",
                      id: "filterType_1",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.radioFilter) = $event)),
                      value: 2
                    }, null, 512), [
                      [_vModelRadio, _ctx.radioFilter]
                    ]),
                    _hoisted_44
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("table", _hoisted_46, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
                      return (_openBlock(), _createElementBlock("th", {
                        class: _normalizeClass([ h.sortable ? 'sortable' : '']),
                        onClick: $event => (_ctx.sortTableColumn(index, h.sortable))
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_48, _toDisplayString(h.text), 1),
                          (h.sortable)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass([ _ctx.activeSortHeader === index ? 'active' : '', h.sortMethod])
                              }, _hoisted_50, 2))
                            : _createCommentVNode("", true)
                        ])
                      ], 10, _hoisted_47))
                    }), 256))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_ctx.loadingContent)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_51, [
                        _createElementVNode("td", {
                          colspan: _ctx.tableHeadings.length
                        }, [
                          _createVNode(_component_LoadingIndicator)
                        ], 8, _hoisted_52)
                      ]))
                    : (_ctx.errorLoadingContent)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_53, [
                          _createElementVNode("td", {
                            colspan: _ctx.tableHeadings.length
                          }, [
                            _createVNode(_component_ErrorIndicator)
                          ], 8, _hoisted_54)
                        ]))
                      : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.followUps.length == 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_55, [
                            _createElementVNode("td", {
                              colspan: _ctx.tableHeadings.length
                            }, "No Records", 8, _hoisted_56)
                          ]))
                        : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.followUps.length > 0)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.followUpsDisplay, (i) => {
                              return (_openBlock(), _createElementBlock(_Fragment, null, [
                                (i.followUpType.id == _ctx.radioFilter)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_57, [
                                      _createElementVNode("td", _hoisted_58, [
                                        _createVNode(_component_router_link, {
                                          to: { name: _ctx.RouteN.TA.Practice.n, query: { pId: i.practice.id } },
                                          class: "link"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(i.practice.branchId == null ? i.practice.name :
                    i.practice.name + ' (' + i.practice.branchTradingName + ')'), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"])
                                      ]),
                                      _createElementVNode("td", _hoisted_59, _toDisplayString(i.practice.firmId + (i.practice.branchId == null ? '' : ' - ' +
                  i.practice.branchId)), 1),
                                      _createElementVNode("td", _hoisted_60, _toDisplayString(_ctx.$formatDate(i.closedDate)), 1),
                                      _createElementVNode("td", _hoisted_61, _toDisplayString(i.lastInvestigationType?.name), 1),
                                      _createElementVNode("td", _hoisted_62, _toDisplayString(_ctx.$formatDate(i.reInvestigationDate)), 1),
                                      _createElementVNode("td", _hoisted_63, _toDisplayString(i.investigationType?.name), 1),
                                      _createElementVNode("td", _hoisted_64, [
                                        _createElementVNode("button", {
                                          class: "btn btn-default sml transparent ml-1",
                                          onClick: $event => (_ctx.approve(i)),
                                          disabled: i.followUpStatus.id > 1
                                        }, " Approve ", 8, _hoisted_65),
                                        _createElementVNode("button", {
                                          class: "btn btn-default sml transparent ml-2",
                                          onClick: $event => (_ctx.reject(i)),
                                          disabled: i.followUpStatus.id > 1
                                        }, " Reject ", 8, _hoisted_66)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 256))
                          : _createCommentVNode("", true)
                ])
              ])
            ])
          ], 64))
  ]))
}